import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import { TranslateTextLegacyPage } from './component';

/*
  The purpose of component is to translate text that are still on the engine
  side template.

  It search for all DOM elements that has 'data-translation-key', and create
  portal for each of them, for example:

  <span
    data-translation-key="welcome"
    data-translation-name-space="common"
  >
    Placeholder text
  </span>

  Use this only when it's difficult to refactor engine code to client.

  TODO: remove this component and TranslateTextLegacyPage when we no longer
  need to translate text for template on the engine side.
*/

export const TranslateTextPortals = (): ReactElement[] => {
  const textSpans = document.querySelectorAll('[data-translation-key]');
  const portals: ReactElement[] = [];

  textSpans.forEach((textSpan) => {
    if (textSpan instanceof HTMLElement) {
      const { translationKey, translationNameSpace } = textSpan.dataset;

      if (translationKey && translationNameSpace) {
        // Remove placeholder text
        // eslint-disable-next-line no-param-reassign
        textSpan.innerHTML = '';

        portals.push(
          ReactDOM.createPortal(
            <TranslateTextLegacyPage
              translationNameSpace={translationNameSpace}
              translationKey={translationKey}
            />,
            textSpan
          )
        );
      }
    }
  });

  return portals;
};
